export interface UploadedFile {
  fileName: string;
  data: string | ArrayBuffer;
  file: any;
}

export enum ReadFileFormat {
  None = 0,
  ArrayBuffer = 1,
  DataUrl = 2,
  BinaryString = 3,
  Text = 4
}
